import React from "react";

// Example categories and their facilities
const facilityCategories = [
  {
    title: "Studios & Production",
    items: [
      "Acting Institute",
      "Film Production",
      "OTT – Shows and Movies Production",
      "Editing Studio",
      "VFX Studio",
      "Cinematography & Direction Studio, Green Screen / Chroma studio",
      "Photography Studio",
      "Podcast Studio",
      "Sound & Music Recording (Jamming) Studio",
      "Screening Room",
      "4K movie / preview theatre",
    ],
  },
  {
    title: "Events & Organization",
    items: [
      "Events Organization",
      "Conference Hall",
      "Reception & Waiting Lounge",
      "Changing and Makeup Room",
      "Acting, Dancing & Production Hall",
      "Modelling House",
    ],
  },
  {
    title: "Support & Amenities",
    items: [
      "Marketing and Advertising Production",
      "Dedicated Kitchen and Cafeteria",
    ],
  },
];

const glassStyle = {
  background: "rgba(255,255,255,0.18)",
  borderRadius: "18px",
  boxShadow: "0 8px 32px 0 rgba(74,47,36,0.13)",
  backdropFilter: "blur(14px)",
  WebkitBackdropFilter: "blur(14px)",
  border: "1.5px solid rgba(255,255,255,0.22)",
  padding: "1.2rem 1rem",
  flex: "1 1 30%",
  minWidth: "260px",
  maxWidth: "340px",
  maxHeight: "370px", // limit card height
  overflow: "hidden", // hide overflow content
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  transition: "transform 0.2s, box-shadow 0.2s",
  cursor: "pointer",
  color: "#fff",
};

const Facilities = () => (
  <section
    style={{
      background: "#23160d", // dark chocolate
      minHeight: "100vh",
      position: "relative",
      overflow: "hidden",
      // paddingBottom: "0.5rem", // reduced from "4px"
      marginBottom: "4rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {/* Decorative blobs for background effect */}
    <svg
      style={{
        position: "absolute",
        top: "-60px",
        left: "-120px",
        width: "400px",
        height: "400px",
        zIndex: 0,
        filter: "blur(18px)",
        opacity: 0.7,
      }}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient id="blob1" cx="50%" cy="50%" r="70%">
          <stop offset="0%" stopColor="#fffbe6" stopOpacity="0.95" />
          <stop offset="100%" stopColor="#A14D1F" stopOpacity="0.3" />
        </radialGradient>
      </defs>
      <path
        d="M120,60 Q180,0 260,60 Q340,120 300,200 Q260,280 160,300 Q60,320 80,200 Q100,80 120,60Z"
        fill="url(#blob1)"
      />
    </svg>
    <svg
      style={{
        position: "absolute",
        bottom: "70px",
        right: "-120px",
        width: "420px",
        height: "420px",
        zIndex: 0,
        filter: "blur(22px)",
        opacity: 0.6,
      }}
      viewBox="0 0 420 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient id="blob2" cx="50%" cy="50%" r="70%">
          <stop offset="0%" stopColor="#fffbe6" stopOpacity="0.95" />
          <stop offset="100%" stopColor="#4A2F24" stopOpacity="0.3" />
        </radialGradient>
      </defs>
      <path
        d="M220,80 Q320,0 380,120 Q440,240 320,320 Q200,400 120,320 Q40,240 120,160 Q200,80 220,80Z"
        fill="url(#blob2)"
      />
    </svg>
    <div style={{ maxWidth: 1100, margin: "0 auto", position: "relative", zIndex: 2 }}>
      <h2
        style={{
          textAlign: "center",
          fontSize: "3rem",
          marginBottom: "0.5rem",
          color: "#fff",
          letterSpacing: "2px",
          fontWeight: 800,
          textShadow: "0 4px 24px #4A2F2488",
        }}
      >
        Our Facilities
      </h2>
      <p
        style={{
          textAlign: "center",
          color: "#fff",
          fontSize: "1.15rem",
          marginBottom: "2.2rem",
          fontWeight: 400,
          textShadow: "0 2px 8px #fffbe644",
        }}
      >
        Collaborative spaces to spark creativity and innovation!
      </p>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1.5rem",
          justifyContent: "center",
        }}
      >
        {facilityCategories.map((cat, idx) => (
          <div
            key={cat.title}
            style={{
              ...glassStyle,
              boxShadow:
                idx % 2 === 0
                  ? "0 8px 32px 0 #A14D1F33"
                  : "0 8px 32px 0 #4A2F2433",
              background:
                "linear-gradient(135deg, rgba(255,255,255,0.22) 60%, rgba(161,77,31,0.10) 100%)",
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = "scale(1.045)";
              e.currentTarget.style.boxShadow =
                "0 16px 48px 0 #A14D1F66, 0 2px 12px #4A2F2433";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow =
                idx % 2 === 0
                  ? "0 8px 32px 0 #A14D1F33"
                  : "0 8px 32px 0 #4A2F2433";
            }}
          >
            <h3
              style={{
                fontSize: "1.15rem",
                color: "#fff",
                marginBottom: "0.8rem",
                fontWeight: 700,
                letterSpacing: "1px",
                textShadow: "0 2px 8px #A14D1F22",
              }}
            >
              {cat.title}
            </h3>
            <ul
              style={{
                paddingLeft: 18,
                color: "#fff",
                fontSize: "1.04rem",
                lineHeight: 1.5,
                fontWeight: 500,
                listStyle: "none",
                flex: 1,
                overflowY: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ffffff transparent",
                msOverflowStyle: "auto",
              }}
            >
              <style>
                {`
                  ul::-webkit-scrollbar {
                    width: 7px;
                    background: transparent;
                  }
                  ul::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #A14D1F 60%, #4A2F24 100%);
                    border-radius: 16px;
                  }
                  ul::-webkit-scrollbar-thumb:hover {
                    background: #A14D1F;
                  }
                `}
              </style>
              {cat.items.map((item) => (
                <li
                  key={item}
                  style={{
                    marginBottom: 8,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    color: "#fff",
                    fontWeight: 500,
                    letterSpacing: "0.2px",
                    textShadow: "0 1px 4px #A14D1F44",
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      width: 7,
                      height: 7,
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg, #A14D1F 60%, #fffbe6 100%)",
                      marginRight: 8,
                      boxShadow: "0 1px 4px #A14D1F44",
                    }}
                  />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Facilities;
